import { Text, View } from 'dripsy';
import * as React from 'react';
import { FixedSizeList } from 'react-window';
import { AutocompleteItem } from './AutocompleteItem';
export const AutocompleteList = React.memo(React.forwardRef(({ autocompleteId, listHeight, itemHeight, keyword, hoveredItem, onItemSelect, onItemHover, onScroll, options = [], }, forwardedRef) => (React.createElement(View, { sx: {
        paddingY: '$2',
        paddingLeft: '$4',
        paddingRight: '$2',
        backgroundColor: 'white',
    }, pointerEvents: "auto" },
    React.createElement(FixedSizeList, { ref: forwardedRef, width: "100%", itemCount: options.length, height: listHeight, itemSize: itemHeight, onScroll: onScroll, role: "listbox" }, ({ index, style }) => (React.createElement(View, { style: style, sx: { paddingRight: '$3' }, key: index },
        React.createElement(AutocompleteItem, { label: options[index].label, keyword: keyword, isHovered: hoveredItem === index, isSelected: options[index].label === keyword, nativeID: `${autocompleteId}-item-${index}`, onMouseEnter: () => onItemHover(index), onMouseDown: (event) => {
                event.preventDefault();
                onItemSelect(options[index]);
            } })))),
    options.length === 0 && (React.createElement(Text, { sx: { lineHeight: '$2', fontWeight: 'normal', paddingY: '$2' } }, "No result found."))))));
AutocompleteList.displayName = 'AutocompleteList';
//# sourceMappingURL=AutocompleteList.js.map